module.exports = __webpack_public_path__ + "img/noimg.625d1aff.jpg";